import React from 'react';

const TotalRecordsCard = ({ totalRecords, selectedYear, clinicName }) => {
  return (
    <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg shadow-lg p-5 mb-5 text-white">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-blue-100 text-sm font-medium uppercase tracking-wide">Total Birth Records</p>
          <p className="text-4xl font-bold mt-2">{totalRecords.toLocaleString()}</p>
          <p className="text-blue-100 text-sm mt-2">
            {selectedYear ? `Year: ${selectedYear}` : 'All time'}
            {clinicName && ` • ${clinicName}`}
          </p>
        </div>
        <div className="bg-white bg-opacity-20 rounded-full p-4">
          <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default TotalRecordsCard;
